import { post, get } from 'axios'

const host = process.env.VUE_APP_CCAPI

function upload (tokenAuth, documentList) {
    const resource = `/fas/loan_request/upload`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: tokenAuth,
        document_list: documentList
    };

    return post(API_URL,  params, config )
}

function getDocumentsType (tokenAuth) {
    const resource = `/fas/get_all_documents_requireds`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: tokenAuth
    };

    return get(API_URL, { params, config })
}

function uploadRenounceSavingDocuments (tokenAuth, id, documentList) {
    const resource = `/fas/withdraw_saving_request/upload_document`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: tokenAuth,
        id: id,
        document_list: documentList
    };

    return post(API_URL,  params, config )
}

function getDocumentsRequired (tokenAuth, requeriedIn) {
    const resource = `/fas/documents/get_documents_requiered`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: tokenAuth,
        requeried_in: requeriedIn
    };

    return get(API_URL, { params, config })
}

function getRetirementDocumentsAttached (tokenAuth, retirementId) {
    const resource = `/fas/retirement_request/get_links_documents`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: tokenAuth,
        retirement_request_id: retirementId
    };

    return get(API_URL, { params, config })
}

function getRefundDocumentsAttached (tokenAuth, retirementId) {
    const resource = `/fas/undue_discount_request/get_links_documents`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: tokenAuth,
        id: retirementId
    };

    return get(API_URL, { params, config })
}

function getSavingDocumentsAttached (tokenAuth, savingId) {
    const resource = `/fas/withdraw_saving_request/get_links_documents`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: tokenAuth,
        withdraw_saving_request_id: savingId
    };

    return get(API_URL, { params, config })
}

export default {
    upload: upload,
    getDocumentsType: getDocumentsType,
    uploadRenounceSavingDocuments: uploadRenounceSavingDocuments,
    getDocumentsRequired: getDocumentsRequired,
    getRetirementDocumentsAttached: getRetirementDocumentsAttached,
    getRefundDocumentsAttached: getRefundDocumentsAttached,
    getSavingDocumentsAttached: getSavingDocumentsAttached
}